/**
 * @generated SignedSource<<2434022b17548311de420a4b8de833d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingCustomsDisclaimer_item$data = {
  readonly dutiesInfo: {
    readonly duties: string | null;
  } | null;
  readonly " $fragmentType": "PdpSharedShippingCustomsDisclaimer_item";
};
export type PdpSharedShippingCustomsDisclaimer_item$key = {
  readonly " $data"?: PdpSharedShippingCustomsDisclaimer_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingCustomsDisclaimer_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingCustomsDisclaimer_item",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        }
      ],
      "concreteType": "dutiesInfo",
      "kind": "LinkedField",
      "name": "dutiesInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "duties",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "fff10bfb3dfa0a8744d9ad8e02efc638";

export default node;
